import { PanelHeader, PanelHeaderProps } from "@/components/panels/PanelHeader/PanelHeader";
import { DebouncedInput, Icon, InputProps } from "@vintecc/components";
import { FC } from "react";
import { useCommonTranslation } from "@/services/culture/common.translations";

import { faSearch } from "@vintecc/pro-light-svg-icons";

export interface PanelSearchHeaderProps extends PanelHeaderProps {
  search: string;
  setSearch: (search: string) => void;
  inputProps?: InputProps;
  searchInputTestId?: string;
}

export const PanelSearchHeader: FC<PanelSearchHeaderProps> = ({ search, setSearch, inputProps, searchInputTestId, ...panelHeaderProps }) => {
  const { t } = useCommonTranslation();
  return (
    <PanelHeader {...panelHeaderProps}>
      <DebouncedInput
        autoFocus
        placeholder={t("common.search")}
        aria-label={t("common.search")}
        className="mt-4"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        endIcon={<Icon icon={faSearch} className="text-primary" />}
        testId={searchInputTestId}
        {...inputProps}
      />
    </PanelHeader>
  );
};
